module.exports = __webpack_public_path__ + "img/cykel1.3f2ca9a4.jpg";